import React from 'react';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, EffectFade, Autoplay, Navigation } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import HeroShapeDividerBottom from '../assets/Images/intersecting-wave-layers.svg';
import { ReactComponent as DNAIcon } from '../assets/icons/dna-icon.svg';
import { ReactComponent as ServiceIcon01 } from '../assets/icons/service-icon-01.svg';
import { ReactComponent as ServiceIcon02 } from '../assets/icons/service-icon-02.svg';
import { ReactComponent as ServiceIcon03 } from '../assets/icons/service-icon-03.svg';
import AboutImage1 from '../assets/Images/about1.png';
import AboutImage2 from '../assets/Images/about2.png';
import AboutImage3 from '../assets/Images/about3.png';
import CerificateOne from '../assets/Images/certificate-1.png';
import CerificateTwo from '../assets/Images/certificate-2.png';
import CerificateThree from '../assets/Images/certificate-3.png';
import CerificateFour from '../assets/Images/certificate-4.png';
import CerificateFive from '../assets/Images/certificate-5.png';
import CerificateSix from '../assets/Images/certificate-6.png';
import CerificateSeven from '../assets/Images/certificate-7.png';
import CerificateEight from '../assets/Images/certificate-8.png';
import CerificateNine from '../assets/Images/certificate-9.png';
import CerificateTen from '../assets/Images/certificate-10.png';
import CerificateEleven from '../assets/Images/certificate-11.png';
import Cerificate12 from '../assets/Images/certificate-12.png';
import Cerificate13 from '../assets/Images/certificate-13.png';
import Cerificate14 from '../assets/Images/certificate-14.png';
import CounterTopdivider from '../assets/Images/layered-wave.svg';
import { ReactComponent as Ratingstar } from '../assets/icons/star.svg';
import { ReactComponent as UserIcon } from '../assets/icons/user.svg';
import { ReactComponent as ExploreArrow } from '../assets/icons/right-arrow.svg';
import Globe from '../assets/Images/globe-img.jpg';
import WorldMap from "react-svg-worldmap";
import { useNavigate } from "react-router-dom";
import Partner1 from '../assets/Images/partner1.png';
import Partner2 from '../assets/Images/partner2.png';
import Partner3 from '../assets/Images/partner3.png';
import Partner4 from '../assets/Images/partner4.png';
import Partner5 from '../assets/Images/partner5.png';
import Partner6 from '../assets/Images/partner6.png';
import Partner7 from '../assets/Images/partner7.png';
import Partner8 from '../assets/Images/partner8.jpeg';
import Partner9 from '../assets/Images/partner9.jpeg';
import Partner10 from '../assets/Images/partner10.jpeg';



const Home = () => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1
    });

    // const data = [
    //     { country: "KE", value: "" },  // Kenya
    //     { country: "UG", value: "" },  // Uganda
    //     { country: "PE", value: "" },  // Peru
    //     { country: "NG", value: "" }, // Nigeria
    //     { country: "KH", value: "" },  // Cambodia
    //     { country: "YE", value: "" },  // Yemen
    //     { country: "GH", value: "" },  // Ghana
    //     { country: "ET", value: "" }, // Ethiopia
    //     { country: "TZ", value: "" },  // Tanzania
    //     { country: "PH", value: "" }, // Philippines
    //     { country: "CD", value: "" },  // DR Congo
    //     { country: "RW", value: "" },  // Rwanda
    //     { country: "AE", value: "" }    // UAE
    // ];

    const data = [
        { country: "KE", value: "" }, // Kenya
        { country: "UG", value: "" }, // Uganda
        { country: "PE", value: "" }, // Peru
        { country: "NG", value: "" }, // Nigeria
        { country: "KH", value: "" }, // Cambodia
        { country: "YE", value: "" }, // Yemen
        { country: "GH", value: "" }, // Ghana
        { country: "ET", value: "" }, // Ethiopia
        { country: "TZ", value: "" }, // Tanzania
        { country: "PH", value: "" }, // Philippines
        { country: "CD", value: "" }, // DR Congo
        { country: "RW", value: "" }, // Rwanda
        { country: "AE", value: "" }, // UAE
        { country: "AF", value: "" }, // Afghanistan
        { country: "AR", value: "" }, // Argentina
        { country: "AU", value: "" }, // Australia
        { country: "AZ", value: "" }, // Azerbaijan
        { country: "BD", value: "" }, // Bangladesh
        { country: "BY", value: "" }, // Belarus
        { country: "BE", value: "" }, // Belgium
        { country: "BJ", value: "" }, // Benin
        { country: "BR", value: "" }, // Brazil
        { country: "CA", value: "" }, // Canada
        { country: "CL", value: "" }, // Chile
        { country: "DO", value: "" }, // Dominican Republic
        { country: "EC", value: "" }, // Ecuador
        { country: "EG", value: "" }, // Egypt
        { country: "FJ", value: "" }, // Fiji
        { country: "FR", value: "" }, // France
        { country: "GE", value: "" }, // Georgia
        { country: "GT", value: "" }, // Guatemala
        { country: "GY", value: "" }, // Guyana
        { country: "HN", value: "" }, // Honduras
        { country: "JM", value: "" }, // Jamaica
        { country: "JO", value: "" }, // Jordan
        { country: "KZ", value: "" }, // Kazakhstan
        { country: "KG", value: "" }, // Kyrgyzstan
        { country: "MV", value: "" }, // Maldives
        { country: "MN", value: "" }, // Mongolia
        { country: "MZ", value: "" }, // Mozambique
        { country: "NA", value: "" }, // Namibia
        { country: "NI", value: "" }, // Nicaragua
        { country: "PL", value: "" }, // Poland
        { country: "SS", value: "" }, // South Sudan
        { country: "LK", value: "" }, // Sri Lanka
        { country: "SD", value: "" }, // Sudan
        { country: "TJ", value: "" }, // Tajikistan
        { country: "TH", value: "" }, // Thailand
        { country: "UA", value: "" }, // Ukraine
        { country: "GB", value: "" }, // United Kingdom
        { country: "UZ", value: "" }, // Uzbekistan
        { country: "VE", value: "" }, // Venezuela
        { country: "VN", value: "" }, // Vietnam
        { country: "ZM", value: "" }, // Zambia
        { country: "ZW", value: "" }  // Zimbabwe
    ];


    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/about#services");
        setTimeout(() => {
            const element = document.getElementById("services");
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }, 100); // Delay ensures React Router updates first
    };


    return (
        <main>
            <section className="hero-wrapper">
                <Swiper className="swiper mySwiper h-100"
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: true,
                    }}
                    loop={true}
                    slidesPerView={1}
                    navigation={{
                        nextEl: '.swiper-nav .swiper-button-next',
                        prevEl: '.swiper-nav .swiper-button-prev',
                    }}
                    modules={[Pagination, EffectFade, Autoplay, Navigation]}
                    effect="fade" >
                    <SwiperSlide>
                        <div className="inner-wrapper slide1">
                            <div className="container">
                                <div className="row">
                                    <div className="col-xxl-8 col-lg-10" data-aos="fade-right" data-aos-duration="2000">
                                        <div className="banner-subtitle text-white"><DNAIcon className="svg-fill-white" /> welcome to Avnain</div>
                                        <h1 className="hero-heading sora-font">Explore Our  <span
                                            className="fw-normal">Product Range</span></h1>
                                        <Link to="/products" className="btn-grad d-inline-block">
                                            learn more
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="inner-wrapper slide2">
                            <div className="container">
                                <div className="row">
                                    <div className="col-xxl-8 col-lg-10" data-aos="fade-right" data-aos-duration="2000">
                                        <div className="banner-subtitle text-white"><DNAIcon className="svg-fill-white" />Welcome to Avnain</div>
                                        <h2 className="hero-heading sora-font">Get a Quote for  <span className="fw-normal"> Bulk Orders</span></h2>
                                        <Link to="/contact" className="btn-grad d-inline-block">
                                            learn more
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="inner-wrapper slide1">
                            <div className="container">
                                <div className="row">
                                    <div className="col-xxl-8 col-lg-10" data-aos="fade-right" data-aos-duration="2000">
                                        <div className="banner-subtitle text-white"><DNAIcon className="svg-fill-white" /> welcome to Avnain</div>
                                        <h1 className="hero-heading sora-font">Partner With Us</h1>
                                        <button onClick={handleClick} className="btn-grad d-inline-block border-0">
                                            learn more
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
                <div className="container position-relative">
                    <div className='swiper-nav'>
                        <div className="swiper-button swiper-button-next"></div>
                        <div className="swiper-button swiper-button-prev"></div>
                    </div>
                </div>

                <div className="shape-divider-bottom">
                    <img src={HeroShapeDividerBottom} alt="shape-divider-bottom" width="100%"
                        height="auto" />
                </div>
            </section>

            <section className="about-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="row position-relative z-1 about-div" >
                                <img src={AboutImage1} alt="About" width="100%" height="100%" />
                                <img src={AboutImage2} className='about-image-2 about-img infinite-slide' alt="About" width="100%" height="100%" />
                                <img src={AboutImage3} className='about-image-3 about-img infinite-slide2' alt="About" width="100%" height="100%" />
                            </div>

                        </div>
                        <div className="col-lg-6 ps-lg-5 mt-lg-0 pt-lg-0 pt-5 mt-5" data-aos="fade-left" data-aos-duration="2000">
                            <div className="banner-subtitle secondary-text"><DNAIcon /> About AVNA Pvt Ltd</div>
                            <h2 className='section-title my-sm-2 my-0'>Your Trusted Partner in Pharmaceutical & Healthcare Manufacture and supply</h2>
                            <p className='para-text my-3'>AVNA Pvt Ltd is a healthcare sourcing and supply company based in Ahmedabad, India, supporting both domestic and international markets.</p>
                            <p className='para-text my-3'>Our portfolio includes pharmaceutical formulations, APIs, surgical products, nutraceuticals, veterinary medicines, cosmeceuticals, and Ayurvedic products sourced through trusted manufacturing partners.</p>
                            <p className='para-text my-3'>With access to 5,500+ healthcare products, AVNA works closely with distributors, hospitals, pharmacies, and healthcare companies to provide reliable supply, consistent quality, and competitive pricing.</p>
                        </div>
                    </div>
                </div>
                <div className="shape-divider-bottom">
                    <img src={HeroShapeDividerBottom} alt="shape-divider-bottom" width="100%"
                        height="auto" />
                </div>
            </section>

            <section className='services-wrapper'>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12 text-center">
                            <div className="banner-subtitle secondary-text"><DNAIcon className="" />Our Services</div>
                            <h2 className='section-title my-sm-2 my-0'>Global Pharmaceutical Supply & Export Solutions</h2>
                            <p className='para-text my-3 col-md-7 mx-auto'>At Avna Pvt Ltd, we provide comprehensive pharmaceutical manufacturing support and export solutions to global distributors, importers, hospitals, and healthcare organizations. Our services are designed to simplify international procurement while ensuring quality, compliance, and reliable delivery.</p>
                        </div>
                    </div>
                    <div className="row mt-lg-5 pt-lg-5">
                        <div className="col-lg-4">
                            <div className="services-box-wrapper">
                                <div className="services-inner box">
                                    <div className="media_wrap" data-aos="zoom-in" data-aos-duration="3000">
                                        <ServiceIcon01 />
                                    </div>
                                    <div className="services-box-content">
                                        <div className="services-box-title">
                                            <h3 className="title">Pharmaceutical Export Services</h3>
                                        </div>
                                        <div className="desc-text">
                                            We specialize in the global export of pharmaceuticals, nutraceuticals, surgical disposables, cosmeceuticals, and Ayurvedic products. <br></br>
                                            Our team manages the complete export process including product sourcing, documentation, regulatory compliance, and international logistics to ensure smooth and timely delivery.
                                        </div>
                                        <Link to='products' className='explore-btn'>  Explore more <ExploreArrow className='icon' /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="services-box-wrapper">
                                <div className="services-inner box">
                                    <div className="media_wrap" data-aos="zoom-in" data-aos-duration="3000">
                                        <ServiceIcon02 />
                                    </div>
                                    <div className="services-box-content">
                                        <div className="services-box-title">
                                            <h3 className="title">Contract Manufacturing Support</h3>
                                        </div>
                                        <div className="desc-text">
                                            Through our network of WHO-GMP certified manufacturing partners, we support international buyers with reliable contract manufacturing solutions.
                                            We assist with: <br></br>
                                            - Custom product manufacturing <br></br>
                                            - Private labeling <br></br>
                                            - Product customization according to market requirements <br></br>
                                            - Bulk production and supply <br></br>
                                            - Product Sourcing & Global Supply <br></br>

                                            With access to a large portfolio of healthcare products, we help buyers source the right products at competitive prices.
                                        </div>
                                        <Link to='products' className='explore-btn'>  Explore more <ExploreArrow className='icon' /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="services-box-wrapper">
                                <div className="services-inner box">
                                    <div className="media_wrap" data-aos="zoom-in" data-aos-duration="3000">
                                        <ServiceIcon03 />
                                    </div>
                                    <div className="services-box-content">
                                        <div className="services-box-title">
                                            <h3 className="title">Our sourcing services include:
                                            </h3>
                                        </div>
                                        <div className="desc-text">
                                            - Pharmaceutical finished formulations <br></br>
                                            - Nutraceutical supplements <br></br>
                                            - Surgical and hospital disposables <br></br>
                                            - Ayurvedic and herbal products <br></br>
                                            We ensure quality assurance, regulatory compliance, and consistent supply for every order.
                                        </div>
                                        <Link to='products' className='explore-btn'>  Explore more <ExploreArrow className='icon' /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='why-choose-us-wrapper py-100'>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6" data-aos="fade-in" data-aos-duration="3000">
                            <div className="banner-subtitle secondary-text"><DNAIcon className="" />Why choose Us</div>
                            <h2 className='section-title my-sm-2 my-0'>Why Choose Us</h2>
                            <p className='para-text my-3'>At Avna Pvt Ltd, we are committed to delivering reliable pharmaceutical and healthcare solutions to international markets. Our focus on quality, compliance, and long-term partnerships makes us a trusted partner for distributors, importers, and healthcare organizations worldwide.<br></br> <br></br>

                                <b>Global Export Expertise</b> <br></br>

                                With hands-on experience in international pharmaceutical trade, we understand the complexities of global markets, documentation, and regulatory requirements. Our team ensures smooth and efficient export operations for our partners. <br></br><br></br>

                                <b>Trusted Manufacturing Network</b><br></br>

                                We collaborate with WHO-GMP certified manufacturing partners to provide high-quality pharmaceutical, nutraceutical, surgical, and healthcare products that meet international standards.<br></br><br></br>

                                <b>Wide Product Portfolio</b><br></br>

                                Our portfolio includes pharmaceutical formulations, nutraceutical supplements, surgical disposables, cosmeceuticals, and Ayurvedic products, allowing buyers to source multiple healthcare products from a single trusted supplier.</p>

                        </div>
                        <div className="col-lg-6 text-center" data-aos="fade-left" data-aos-duration="3000">
                            <img src={Globe} alt="Globe" className='globe-img' />
                        </div>
                    </div>
                </div>
            </section>

            <section className='counter-wrapper'>
                <div className="divider-top">
                    <img src={CounterTopdivider} alt="shape-divider-bottom" width="100%"
                        height="auto" />
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7 text-center">
                            <div className="banner-subtitle secondary-text"><DNAIcon className="" />Trusted Worldwide</div>
                            <h2 className='section-title my-sm-2 my-0'>Our Achievements in Numbers</h2>
                            <p className='para-text my-3'>Empowering Global Healthcare Through Our Expertise</p>
                        </div>
                    </div>
                    <div className="row" ref={ref}>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="counter-box">
                                <h3 className='count-title space-font'>
                                    {inView && <CountUp end={169} duration={12} />} <span>+</span>
                                </h3>
                                <p className='count-desc'>CTD Dossier</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="counter-box">
                                <h3 className='count-title space-font'>
                                    {inView && <CountUp end={359} duration={12} />} <span>+</span>
                                </h3>
                                <p className='count-desc'>Total registrations</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="counter-box">
                                <h3 className='count-title space-font'>
                                    {inView && <CountUp end={69} duration={12} />} <span>+</span>
                                </h3>
                                <p className='count-desc'>Countries</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="counter-box">
                                <h3 className='count-title space-font'>
                                    {inView && <CountUp end={159} duration={12} />} <span>+</span>
                                </h3>
                                <p className='count-desc'>Wholesalers world wide</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="divider-bottom">
                    <img src={CounterTopdivider} alt="shape-divider-bottom" width="100%"
                        height="auto" />
                </div>
            </section>

            <section className='map-wrapper'>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-lg-7 text-center">
                            <div className="banner-subtitle secondary-text"><DNAIcon className="" />Global Presence</div>
                            <h2 className='section-title my-sm-2 my-0'>Global Presence</h2>
                            <p className='para-text my-3 col-md-7 mx-auto'>Avna is proud to deliver high-quality complex generics to
                                5 countries across five continents.</p>
                        </div>
                    </div>
                    <div className="col-12 d-flex justify-content-center">
                        <WorldMap
                            color="#1A5A92"
                            data={data}
                            className="map"
                            style={{ width: "100%", }}
                        />
                    </div>
                </div>
            </section>

            <section className='certificate-wrapper'>
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-7 text-center">
                            <div className="banner-subtitle secondary-text"><DNAIcon className="" />Quality Global Outreach</div>
                            <h2 className='section-title my-sm-2 my-0'>Our Certifications</h2>
                            <p className='para-text my-3'>We are the largest exporter of pharmaceutical, nutraceutical, and cosmeceutical products into various countries across the world with quality and certifications that are simply unmatched, be it the EU-GMP approval, PIC/S approval, WHO-GMP approval, and USFDA approval.</p>
                        </div>

                        <div className="col-lg-12">
                            <Swiper
                                slidesPerView={1}
                                spaceBetween={0}
                                breakpoints={{
                                    576: {
                                        slidesPerView: 4,
                                        spaceBetween: 0,
                                    },
                                }}
                                loop={true}
                                speed={6000} // Adjust for smoother scrolling
                                autoplay={{
                                    delay: 0, // Continuous autoplay without delay
                                    disableOnInteraction: false, // Keep autoplay even after user interaction
                                }}
                                pagination={true}
                                modules={[Pagination, Autoplay]} // Ensure Autoplay module is included
                                className="certificateSlider"
                            >
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateOne} alt="Certificate one" width='100%' height="100%" />
                                        <span>CD & DA SRILANKA </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateTwo} alt="Certificate two" width='100%' height="100%" />
                                        <span>NDA UGANDA </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateThree} alt="Certificate three" width='100%' height="100%" />
                                        <span>NAFDAC NIGERIA </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateFour} alt="Certificate four" width='100%' height="100%" />
                                        <span>MRA AZERBAIJAN</span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateFive} alt="Certificate five" width='100%' height="100%" />
                                        <span> MOH LIBYA </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateSix} alt="Certificate six" width='100%' height="100%" />
                                        <span>MOH KUWAIT</span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateSeven} alt="Certificate six" width='100%' height="100%" />
                                        <span>U.S FOOD & DRUG </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateNine} alt="Certificate six" width='100%' height="100%" />
                                        <span>PPB KENYA </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateTen} alt="Certificate six" width='100%' height="100%" />
                                        <span>WHO-GMP </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateEight} alt="Certificate six" width='100%' height="100%" />
                                        <span>MOH YEMEN </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={CerificateEleven} alt="Certificate six" width='100%' height="100%" />
                                        <span>FDA GHANA </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Cerificate12} alt="Certificate six" width='100%' height="100%" />
                                        <span>DPM IVORY COAST </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Cerificate13} alt="Certificate six" width='100%' height="100%" />
                                        <span>ISO
                                            9001:2008 </span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Cerificate14} alt="Certificate six" width='100%' height="100%" />
                                        <span>FDA  PHILIPPINES</span>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>
                    </div>
                </div>
            </section>

            <section className='testimonial-wrapper'>
                <div className="container">
                    <div className="row justify-content-center mb-5" data-aos="fade-up" data-aos-duration="2000">
                        <div className="col-lg-7 text-center">
                            <div className="banner-subtitle secondary-text"><DNAIcon className="" />what people say</div>
                            <h2 className='section-title my-sm-2 my-0'>Our Testimonials</h2>
                            <p className='para-text my-3 col-md-9 mx-auto'>Specializing in exporting pharmaceuticals, nutraceuticals, and ayurvedic products with a strong focus on quality.</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 testimonial-inner-wrapper" data-aos="fade-right" data-aos-duration="2000">
                            <Swiper
                                slidesPerView={1}
                                spaceBetween={0}
                                loop={true}
                                autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: true,
                                }}
                                navigation={{
                                    nextEl: '.swiper-nav-testimonial .swiper-button-next',
                                    prevEl: '.swiper-nav-testimonial .swiper-button-prev',
                                }}
                                modules={[Navigation]}
                                className="testimonialSlider"
                            >
                                <SwiperSlide>
                                    <div className="testimonial-box">
                                        <div className="d-flex rating-box">
                                            <Ratingstar />
                                            <Ratingstar />
                                            <Ratingstar />
                                            <Ratingstar />
                                            <Ratingstar />
                                        </div>
                                        <p className='desc'>AVNain's dedication to excellence and adherence to international standards has set them apart in the industry. Their pharmaceuticals have consistently met our high standards, ensuring patient safety and satisfaction.</p>
                                        <div className="d-flex author-box">
                                            <UserIcon />
                                            <span>Sara Smith</span>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="testimonial-box">
                                        <div className="d-flex rating-box">
                                            <Ratingstar />
                                            <Ratingstar />
                                            <Ratingstar />
                                            <Ratingstar />
                                            <Ratingstar />
                                        </div>
                                        <p className='desc'>AVNain has been a game-changer for our pharmaceutical supply chain. Their commitment to quality and timely delivery has significantly improved our operations. We highly recommend AVNain for anyone looking for a reliable pharmaceutical export partner.</p>
                                        <div className="d-flex author-box">
                                            <UserIcon />
                                            <span>Ravi Sharma</span>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="testimonial-box">
                                        <div className="d-flex rating-box">
                                            <Ratingstar />
                                            <Ratingstar />
                                            <Ratingstar />
                                            <Ratingstar />
                                            <Ratingstar />
                                        </div>
                                        <p className='desc'>Avna pvt ltd is a reliable partner for exporting pharmaceuticals and ayurvedic products.</p>
                                        <div className="d-flex author-box">
                                            <UserIcon />
                                            <span>Vikram Singh</span>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                            <div className="container position-relative px-0 py-4">
                                <div className='swiper-nav-testimonial'>
                                    <div className="swiper-button swiper-button-next"></div>
                                    <div className="swiper-button swiper-button-prev"></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 px-0 d-flex flex-lg-column flex-sm-row flex-column justify-content-center" data-aos="fade-left" data-aos-duration="2000">
                            <div className="feature-box one">
                                <ServiceIcon02 className="icon-wrapper" />
                                <h4 className='feature-title'>Product Development Services</h4>
                                <p className='feature-desc'>Offering services such as product development, contract manufacturing, and export assistance with global outreach.
                                </p>
                            </div>
                            <div className="feature-box">
                                <ServiceIcon03 className="icon-wrapper" />
                                <h4 className='feature-title'>Customer-Centric Approach</h4>
                                <p className='feature-desc'>Emphasizing a customer-centric approach with over two years of experience in the industry.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='certificate-wrapper'>
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-7 text-center">
                            <div className="banner-subtitle secondary-text"><DNAIcon className="" />Quality Global Outreach</div>
                            <h2 className='section-title my-sm-2 my-0'>Our partners</h2>
                        </div>

                        <div className="col-lg-12">
                            <Swiper
                                slidesPerView={1}
                                spaceBetween={0}
                                breakpoints={{
                                    576: {
                                        slidesPerView: 4,
                                        spaceBetween: 0,
                                    },
                                }}
                                loop={true}
                                speed={6000} // Adjust for smoother scrolling
                                autoplay={{
                                    delay: 0, // Continuous autoplay without delay
                                    disableOnInteraction: false, // Keep autoplay even after user interaction
                                }}
                                pagination={true}
                                modules={[Pagination, Autoplay]} // Ensure Autoplay module is included
                                className="certificateSlider"
                            >
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Partner1} alt="Certificate one" width='100%' height="100%" />

                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Partner2} alt="Certificate two" width='100%' height="100%" />

                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Partner3} alt="Certificate three" width='100%' height="100%" />

                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Partner4} alt="Certificate four" width='100%' height="100%" />

                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Partner5} alt="Certificate five" width='100%' height="100%" />

                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Partner6} alt="Certificate six" width='100%' height="100%" />

                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Partner7} alt="Certificate six" width='100%' height="100%" />

                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Partner8} alt="Certificate six" width='100%' height="100%" />

                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Partner9} alt="Certificate six" width='100%' height="100%" />

                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="certificate-box">
                                        <img src={Partner10} alt="Certificate six" width='100%' height="100%" />

                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Home;